$(function () {
    var custom_text = $(".stock-text").data('customtext');
    if (custom_text == "false") {
        custom_text = false;
    }
  
    $(".stock-text").text("Checking stock...");
    $(".stock-colour-img").show();
    $(".stock-colour-img").css("background", "#000000");

    window.onload = function () {
        setTimeout(function () {
            if ($(".stockCount").text().length === 0) {
                let leadTime = !$("#lead-time").length ? "6-8 weeks." : $("#lead-time").val()
                $(".stock-text").text("");
                $(".stock-colour-img").show();
                $(".stock-colour-img").css("background", "#000000");
                $(".stock-text").css("color", "#000000");
                if (custom_text) {
                    $(".stock-text").text(custom_text); // Was "Made to Order"
                  
                } else {
                    $(".stock-text").text("Expected Delivery"); // Was "Made to Order"
                }
                $(".stock-notice-delivery-text").show()
                $(".stock-notice-delivery-text").text("Delivered in " + leadTime);
                $(".stock-text-info").show();
                $(".stock-text-info").attr(
                    "title",
                    "This product is made to order, the lead time is " + leadTime + "."
                );
                $(".out-of-stock-email-wrapper").css("display", "flex");
            }
        }, 10000);
    };

    var waitForEl = function (selector, callback) {
        if (jQuery(selector).length) {
            $(".stock-text").text("");
            callback();
        } else {
            setTimeout(function () {
                waitForEl(selector, callback);
            }, 1);
        }
    };


    waitForEl(".stockCount", function () {
        $(".stock-text").text("");
        let leadTime = !$("#lead-time").length ? "6-8 weeks." : $("#lead-time").val()
        let stock = parseInt($(".stockCount").text());
        if (stock <= 0 || $("#is_available").val() === "false") {
            $(".stock-colour-img").show();
            $(".stock-colour-img").css("background", "#000000");
            $(".stock-text").css("color", "#000000");
            if (custom_text) {
                    $(".stock-text").text(custom_text); // Was "Made to Order"
                  
                } else {
                    $(".stock-text").text("Expected Delivery"); // Was "Made to Order"
                }
            $(".stock-notice-delivery-text").show();
            $(".stock-notice-delivery-text").text("Delivered in " + leadTime);
            $(".stock-text-info").show();
            $(".stock-text-info").attr(
                "title",
                "This product is made to order, the lead time is " + leadTime + "."
            );
            $(".out-of-stock-email-wrapper").css("display", "flex");
        } else {
            
            $(".stock-colour-img").show();
            $(".stock-colour-img").css("background", "#068004");
            if ($(".is_reclaimed").length) {
                if (custom_text) {
                    $(".stock-text").text(custom_text);  
                } else {
                    $(".stock-text").text(stock + " In Stock");  
                }
                $(".stock-notice-reclaimed-text").html(
                    "<p>We have " +
                    stock +
                    " in stock, if you're looking for more please browse our entire <a href='/collections/reclaimed-tiles'>Reclaimed Collection</a><p/>"
                );
            } else {
                if (custom_text) {
                    $('.stock-text').text(custom_text);
                } else {
                    $('.stock-text').text("In Stock");
                }
            }
            // $(".stock-notice-delivery-text").text(
            //     "Delivered in " + leadTime
            // );
            $(".stock-notice-delivery-text").text(
                "Delivered in 1 week"
            );
            $(".stock-text").css("color", "#068004");
            $(".stock-notice-delivery-text").show();
            $(".stock-text-info").show();
            $(".out-of-stock-email-wrapper").hide();
        }
    });

    $(".question-header").on("click", function () {
        $(this).children(".question-header-icon").toggleClass("flip");

        if ($(this).next().is(":visible")) {
            $(this)
                .next()
                .slideUp("fast", "linear", function () {
                    $(this).parent().css("height", "52px");
                });
        } else {
            $(this).parent().css("height", "100%");
            $(this).next().slideDown();
        }
    });

    if ($(".pdp-item-info-text").height() > 71) {
        $(".pdp-item-info-text").css("margin-bottom", "1rem");
    }
});

var checkLocale = function () {
    if ($.cookie('cart_currency') === "USD") {
        $('#is_usa').val(true)
        if ($('.boxProduct').val() === "true") {
            $('.metre-squared-text').html("Tiles per box")
            $('.add-to-cart-quantity-input-m2').attr('placeholder', 'ft2')
            $('.quantity-p').html("You can either enter ft<sup>2</sup> or number of boxes")
        } else {
            $('.add-to-cart-quantity-input-m2').attr('placeholder', 'ft2')
            $('.tmp2-table').html("Tiles per ft<sup>2</sup>")
            $('.tmp2-table-val').text(parseFloat($('.tmp2-value').attr('data-tmp2')))
            $('.metre-squared-text').html("Tiles per ft<sup>2</sup>")
            $('.quantity-p').html("You can either enter ft<sup>2</sup> or number of tiles")
        }
    } else {
        if ($('.boxProduct').val() === "true") {
            $('.metre-squared-text').html("Tiles per box")
        } else {
            $('.metre-squared-text').html("Tiles per m<sup>2</sup>")
            $('.tmp2-value').text(parseInt($('.tmp2-value').attr('data-tmp2')))
        }
    }
}